import styled, { keyframes } from "styled-components/macro";
import { Radio, Input, Dropdown, Button, Select } from "antd";
import COLORS from "../../../../../layout/theme/colors/Colors";
import { WEIGHT, SIZES } from "../../../../../layout/theme";

const { Search } = Input;

const linearMove = keyframes`
  from {
    transform: translateX(20%);
  }

  to {
    transform: translateX(0%);
  }
`;

const linearMoveRight = keyframes`
  from {
    transform: translateX(0%);
  }

  to {
    transform: translateX(30%);
  }
`;

export const FiltersLeft = styled.div``;

export const FiltersRight = styled.div``;

export const AntdSearch = styled(Search)`
	& .ant-input-group-addon:last-child {
		display: none;
	}
	& input.ant-input {
		font-size: ${SIZES.level11};
	}
	& input.ant-input {
		height: 35px;
		width: 400px;
	}
	& span.ant-input-affix-wrapper {
		border-radius: 5px !important;
	}
`;

export const SpanCointainer = styled.div`
	margin: 60px 0;
`;
export const Span = styled.span`
	cursor: pointer;
	color: ${COLORS.Secondary};
	margin-right: 60px;
	font-weight: ${WEIGHT.ExtraBold};
`;

export const InnerExportModal = styled.div`
	display: flex;
	flex-direction: column;
	gap: 30px;
	align-items: center;
	align-content: center;
	justify-content: center;
`;

export const ExportButton = styled(Button)`
	width: 220px;
	height: 48px;
	border-radius: 5px;
	font-size: 14px;
`;

export const Arrow = styled.div`
	display: inline-block;
	animation: ${linearMove} 1s linear infinite;
	padding: 2rem 1rem;
	font-size: 1.2rem;
	color: ${COLORS.Success};
`;

export const ArrowRight = styled.div`
	display: inline-block;
	animation: ${linearMoveRight} 1s linear infinite;
	padding: 2rem 1rem;
	font-size: 1.2rem;
	color: ${COLORS.Success};
	position: absolute;
	left: 0;
	top: 490px;
`;

export const Filters = styled.div`
	margin: 0 0 20px 0;
	padding: 18px;
	background: #f8fafc;
	border: 1px solid #e5e7eb;
	border-radius: 16px;
`;

export const RadioOptions = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 20px;
	margin-bottom: 20px;

	.ant-radio-group {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
	}

	.ant-btn {
		border-radius: 10px !important;
	}
`;

export const AntdRadioButton = styled(Radio.Button)`
	border: 1px solid #e5e7eb !important;
	border-radius: 10px !important;
	font-weight: ${WEIGHT.Bold};
	background: #ffffff !important;
	color: #6b7280 !important;
	box-shadow: none !important;

	&.ant-radio-button-wrapper-checked {
		background: #eef2ff !important;
		border-color: #c7d2fe !important;
		color: #3730a3 !important;
	}

	&:before {
		display: none !important;
	}
`;

export const AntdSelect = styled(Select)`
	border: none;
	font-weight: ${WEIGHT.SemiBold};
`;

export const AntdOption = styled.div`
	border: none;
	font-weight: ${WEIGHT.SemiBold};
	color: ${COLORS.Grey};
`;

export const Line = styled.span`
	position: relative;
	color: #9ca3af;

	&::before {
		content: "";
		width: 108%;
		background-color: #cbd5e1;
		height: 2px;
		position: absolute;
		z-index: 1;
		top: 50%;
		left: -2px;
	}
`;

export const OfferPrice = styled.span`
	margin-left: 10px;
	color: #4338ca;
	font-size: ${SIZES.level11};
	font-weight: 700;
`;

export const Price = styled.span`
	font-weight: 600;
	color: #334155;
`;

export const ActionButton = styled.button`
	border: none;
	border-radius: 5px;
	background-color: transparent;
	padding: 5px;
	cursor: pointer;
	color: ${COLORS.Primary};

	&:hover {
		background-color: #eef2ff;
	}
`;

export const UnP = styled.div`
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
`;

export const OptionContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
`;

export const Container = styled.div`
	display: flex;
	width: 100%;
	align-items: center;
	justify-content: space-between;
	gap: 10px;
`;

export const FilterContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
	align-items: center;

	.ant-picker,
	.ant-select-selector {
		height: 40px !important;
		border-radius: 14px !important;
		border: 1px solid #cbd5e1 !important;
		box-shadow: none !important;
		font-size: 16px !important;
	}

	.ant-picker {
		padding: 0 16px !important;
	}

	.ant-select-selector {
		padding: 0 16px !important;
		display: flex !important;
		align-items: center !important;
	}

	.ant-select-selection-placeholder,
	.ant-select-selection-item {
		color: #334155 !important;
		font-size: 16px !important;
	}

	.ant-picker:hover,
	.ant-picker-focused,
	.ant-select-focused .ant-select-selector,
	.ant-select:hover .ant-select-selector {
		border-color: #4f46e5 !important;
		box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.08) !important;
	}

	.ant-picker-range {
		min-width: 260px;
	}

	@media only screen and (max-width: 1200px) {
		.ant-picker-range,
		.ant-select {
			flex: 1 1 220px;
			min-width: 220px;
		}
	}

	@media only screen and (max-width: 768px) {
		.ant-picker-range,
		.ant-select,
		.ant-input-affix-wrapper {
			width: 100%;
			min-width: 100%;
		}
	}
`;

export const FilterSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const FilterActions = styled.div`
	display: flex;
	gap: 12px;
	align-items: center;
	margin-left: auto;

	@media only screen and (max-width: 1200px) {
		margin-left: 0;
	}

	@media only screen and (max-width: 768px) {
		width: 100%;
		flex-direction: column;
	}
`;

export const Section = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
`;

export const TableWrapper = styled.div`
	width: 100%;
	border-radius: 20px;
	overflow: hidden;
`;
